const tools = {
  NONE: '',
  PATH: 'path',
  RESIZE: 'resize',
  ROTATE: 'rotate',
  POINT: 'point',
}

export default tools
